/* eslint-disable react-native/no-color-literals */
import { Delivered } from "@assets/svg/MyDeliveries";
import React, { useState } from "react";
import RightArrow from "@assets/svg/RightArrow";
import { colors } from "@constants/theme";
import { useNavigation } from "@react-navigation/native";
import { fontFamily } from "@utils/styles/fonts";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import InfoModal from "./InfoModal";
import DebitCreditTransactionModal from "./DebitCreditTransactionModal";
import Text from "@components/CustomText";
function PaymentCard({ ledger, showViewDetailsBtn = false }) {
  const [visible, setVisible] = useState(false);
  const [showDebitCreditModal, setShowDebitCreditModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const {
    is_enabled = false,
    title,
    subtitle,
    subtitle2,
    subtitle2_tooltip,
    view_all_btn_text,
    min_pay_amount_text,
    pending_amount_text,
    non_returned_debit_title,
    non_returned_debit_amount_text,
    non_returned_debit_amount,
    returned_debited_credit_title,
    returned_debited_credit_amount_text,
    returned_debited_credit_amount,
    should_show_credit_debit_summary,
    view_items_btn_text,
    waived_amount_title,
    waived_amount_text,
    waived_amount,
    delivery_txn_id,
    show_min_pay_amount,
  } = ledger || {};

  const navigation = useNavigation();

  const navigateToOrderDetails = (order_id) => {
    navigation.navigate("OrderDetails", { order_id });
  };
  if (!is_enabled) {
    return <></>;
  }
  return (
    <View style={styles.cardContainer}>
      <View style={styles.card}>
        <View style={[styles.headerContainer, styles.headerBackground]}>
          <View style={styles.state}>
            <Delivered status="Delivery" />
            <Text style={styles.greenHeaderText}>{title || ""}</Text>
          </View>
        </View>
        <View style={styles.contentPadding}>
          <View style={styles.summaryContainer}>
            <View style={styles.body}>
              <View style={styles.span}>
                <Text style={styles.p} variant="caption_2">
                  {subtitle || ""}
                </Text>
              </View>
              <Text style={styles.amountText}>{pending_amount_text || ""}</Text>
            </View>
            {should_show_credit_debit_summary ? (
              <>
                {non_returned_debit_amount > 0 ? (
                  <View style={[styles.body, styles.bodyWithPadding]}>
                    <View style={styles.span}>
                      <Text style={styles.p} variant="caption_2">
                        {non_returned_debit_title || ""}
                      </Text>
                      <TouchableOpacity
                        testID="view_debit_transactions_details"
                        style={styles.viewItemsButton}
                        onPress={() => {
                          setModalType("DEBIT");
                          setShowDebitCreditModal(true);
                        }}
                      >
                        <Text style={styles.viewItemsText}>
                          {view_items_btn_text || ""}
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <Text variant="body_text_3" style={styles.amountText}>
                      {non_returned_debit_amount_text || ""}
                    </Text>
                  </View>
                ) : null}
                {returned_debited_credit_amount > 0 ? (
                  <View style={[styles.body, styles.bodyWithPadding]}>
                    <View style={styles.span}>
                      <Text style={styles.p} variant="caption_2">
                        {returned_debited_credit_title || ""}
                      </Text>
                      <TouchableOpacity
                        testID="view_credit_transactions_details"
                        style={styles.viewItemsButton}
                        onPress={() => {
                          setModalType("CREDIT");
                          setShowDebitCreditModal(true);
                        }}
                      >
                        <Text style={styles.viewItemsText}>
                          {view_items_btn_text || ""}
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <Text variant="body_text_3" style={styles.amountText}>
                      {returned_debited_credit_amount_text || ""}
                    </Text>
                  </View>
                ) : null}
                {waived_amount > 0 ? (
                  <View style={[styles.body, styles.bodyWithPadding]}>
                    <View style={styles.span}>
                      <Text style={styles.p} variant="caption_2">
                        {waived_amount_title || ""}{" "}
                      </Text>
                    </View>
                    <Text variant="body_text_3" style={styles.amountText}>
                      {waived_amount_text || ""}
                    </Text>
                  </View>
                ) : null}
              </>
            ) : null}
          </View>
          {show_min_pay_amount ? (
            <View style={[styles.body, styles.bodyWithPadding]}>
              <View style={styles.span}>
                <Text style={styles.subtitleText}>{subtitle2 || ""} </Text>
              </View>
              <Text style={styles.amountTextLarge}>
                {min_pay_amount_text || ""}
              </Text>
            </View>
          ) : null}
          {showViewDetailsBtn ? (
            <TouchableOpacity
              testID="view_payment_detail"
              style={styles.footer}
              onPress={() => navigation.navigate("LedgerTxns", { ledger })}
            >
              <View style={styles.viewDetailsBtn}>
                <Text style={styles.viewDetailsTxt}>
                  {view_all_btn_text || ""}
                </Text>
                <RightArrow
                  stroke={colors.extraLightBlack}
                  fill={colors.extraLightBlack}
                  height={12}
                  width={12}
                />
              </View>
            </TouchableOpacity>
          ) : null}
        </View>
      </View>

      <InfoModal
        text={subtitle2_tooltip}
        setVisible={setVisible}
        visible={visible}
      />
      <DebitCreditTransactionModal
        itemDetailsModalVisible={showDebitCreditModal}
        type={modalType}
        setItemDetailsModalVisible={setShowDebitCreditModal}
        deliveryTxnId={delivery_txn_id}
        navigateToOrderDetails={navigateToOrderDetails}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginTop: 8,
    backgroundColor: colors.white,
  },
  card: {
    backgroundColor: colors.white,
    borderWidth: 0.5,
    borderRadius: 10,
    elevation: 2,
    borderColor: colors.lighterBlack,
  },
  headerContainer: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
  },
  headerBackground: {
    backgroundColor: "rgba(0, 171, 89, 0.04)",
  },
  greenHeaderText: {
    fontSize: 12,
    fontFamily: fontFamily.semiBold,
    lineHeight: 18,
    color: colors.plain_green,
    marginHorizontal: 4,
  },
  state: { flexDirection: "row", alignItems: "center" },
  footer: {
    marginTop: 12,
    borderTopWidth: 1,
    borderTopColor: colors.lighterBlack,
    borderStyle: "dashed",
    padding: 16,
    paddingRight: 0,
  },
  viewDetailsBtn: {
    flexDirection: "row",
    alignSelf: "flex-end",
    alignItems: "center",
  },
  viewDetailsTxt: {
    fontFamily: fontFamily.bold,
    fontSize: 16,
    lineHeight: 22,
    marginRight: 8,
  },
  body: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  amountText: {
    color: colors.black,
    lineHeight: 18.26,
  },
  p: {
    color: colors.mediumBlacklightBlack,
    lineHeight: 18,
  },
  span: {
    flexDirection: "row",
    alignItems: "center",
  },
  contentPadding: {
    padding: 12,
  },
  summaryContainer: {
    backgroundColor: "#F8F8F8",
    padding: 8,
    borderRadius: 8,
  },
  bodyWithPadding: {
    paddingTop: 8,
  },
  viewItemsButton: {
    paddingLeft: 4,
  },
  viewItemsText: {
    color: "#165BFC",
    fontSize: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#165BFC",
  },
  subtitleText: {
    fontSize: 14,
    fontFamily: fontFamily.bold,
    color: colors.mediumBlack,
    lineHeight: 23,
  },
  amountTextLarge: {
    fontSize: 18,
    fontFamily: fontFamily.bold,
    lineHeight: 23,
  },
});

export default PaymentCard;
